import type { ApiResponse, SiteStatsData } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getSiteStats: builder.query<ApiResponse<SiteStatsData>, null>({
      query: () => ({
        url: `/site-stats`,
        method: 'GET'
      })
    })
  })
});
export const {
  useGetSiteStatsQuery
} = extendedApiSlice;